import React from 'react';
import propTypes from 'prop-types';
import { Routes, Route } from 'react-router-dom';
import { ReviewAndSubmitListPage } from './ReviewAndSubmitListPage';

export function ReviewAndSubmitPage({ location, isExpanded }) {
  return (
    <Routes location={location}>
      <Route
        path="/"
        element={<ReviewAndSubmitListPage isExpanded={isExpanded} />}
      />
    </Routes>
  );
}

ReviewAndSubmitPage.propTypes = {
  location: propTypes.object.isRequired,
  isExpanded: propTypes.bool.isRequired,
};
